const oldPortalUrl = 'https://slmg-old.fieldassist.in/';
const dashboardAPIUrl = 'https://fadashboardv2-slmg.azurewebsites.net/';
//const dashboardAPIUrl = 'https://localhost:5001/';


export {
    oldPortalUrl,
    dashboardAPIUrl,
}